import { OrderItem } from '@/types/order-list';
import { CellContext } from '@tanstack/react-table';

export const getIsBundleItem = (info: CellContext<OrderItem, unknown>) => {
  const rows = info.table.getRowModel().rows;
  const order = info.row.original;

  if (order.marketInfo.marketName !== 'coupang' || !order.coupangShipmentBoxNo) {
    return false;
  }

  const firstRowMap = new Map<string, string>();
  rows.forEach((row) => {
    const boxNo = (row.original as OrderItem).coupangShipmentBoxNo;
    if (boxNo && !firstRowMap.has(boxNo)) {
      firstRowMap.set(boxNo, row.id);
    }
  });

  const firstRowId = firstRowMap.get(order.coupangShipmentBoxNo);

  return info.cell.row.id !== firstRowId;
};
